import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";

const FaqItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      onClick={toggleAccordion}
      className="pl-3 lg:pl-5 rounded-[12px] border border-solid border-br mb-5 cursor-pointer md:w-[400px] min-w-[300px] max-w[450px]"
    >
      <div className="flex items-center justify-between gap-5  transition-all transform">
        <h4 className="text-[16px] leading-7 lg:leading-8 text-black">
          {item?.question}
        </h4>
        <div
          className={`${
            isOpen && "bg-br text-dr_gray border-one rotate-180"
          } w-7 h-7 lg:w-8 lg:h-8 rounded-full flex items-center justify-center`}
        >
          <FaPlus />
        </div>
      </div>
      {isOpen && (
        <div className="mt-4">
          <p className="text-[14px] leading-6 lg:text-[16px] lg:leading-7">
            {item?.answer}
          </p>
        </div>
      )}
    </div>
  );
};

export default FaqItem;
